import React, { useEffect, useRef } from 'react';
import * as maptiler from '@maptiler/sdk';
import '@maptiler/sdk/dist/maptiler-sdk.css';

maptiler.config.apiKey = process.env.REACT_APP_MAPTILER_API_KEY || 'YOUR_MAPTILER_API_KEY';

const MapComponent = () => {
  const mapContainer = useRef(null);

  useEffect(() => {
    const map = new maptiler.Map({
      container: mapContainer.current,
      // style: maptiler.style.STREETS,
      style: maptiler.MapStyle.STREETS, // style URL
      center: [0, 0],
      zoom: 2,
    });

    return () => map.remove();
  }, []);

  return <div ref={mapContainer} style={{ height: '500px' }} />;
};

export default MapComponent;
